import type { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import type { ErrorSubdomainValue } from '../../../constants';
import { ErrorSubdomain } from '../../../constants';

import { ServerSideError } from './server-side-error';

export class ErrorPage extends ServerSideError {
  private readonly subdomain: ErrorSubdomainValue;

  constructor(message: string, subdomain: ErrorSubdomainValue) {
    super(message, `${subdomain} Error Page`);
    this.subdomain = subdomain;
  }

  public getServerSidePropsResult(
    context: GetServerSidePropsContext
  ): GetServerSidePropsResult<any> {
    switch (this.subdomain) {
      case ErrorSubdomain.NotFoundSubdomain:
      case ErrorSubdomain.SiteUnpublishedSubdomain:
      case ErrorSubdomain.JobDescriptionClosedSubdomain:
        context.res.statusCode = 404;
        break;
      default:
        context.res.statusCode = 500;
        break;
    }

    return {
      props: { errorSubdomain: this.subdomain },
    };
  }
}
